import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { ListRow } from './ListRow'
import { Table } from '@ztechapps/webui.data-tools'
import { productFieldsData } from './productFieldsData'
import { useDefaultMetadata } from './useDefaultMetadata'
import { Stack } from 'react-bootstrap'
import { actionFieldsData } from './actionFieldsData'

export const Description = ({ show }) => {
  const defaultMetadataData = useDefaultMetadata()

  return (
    <ShowIf condition={show}>
      <Stack gap={2}>
        <div>
          <ul>
            <li>
              You can upload or import the param file as many times as needed — it will simply <b>update or override</b>{' '}
              the existing values. If you make a mistake or want to update the same product, just re-import the file.
            </li>

            <li>
              We use the <b>code</b> key to identify and match the product during import.
            </li>
          </ul>
        </div>

        <div>
          <div>Default metadata keys.</div>
          <Table dataArray={defaultMetadataData ?? []} row={ListRow} />
        </div>

        <div>
          <div>
            Metadata keys used as reference to product fields. Updating or importing this keys will also update the
            corresponding product field
          </div>

          <Table dataArray={productFieldsData} row={ListRow} />
        </div>

        <div>
          <div>Action Metadata keys, this will be used to run custom actions</div>

          <Table dataArray={actionFieldsData} row={ListRow} />
        </div>
      </Stack>

      <hr />
    </ShowIf>
  )
}
